import { Title1 } from '@fluentui/react-components';
import type { ClaimReport } from '@this/shared/dist/data/claim-report.js';
import { useStyles } from './_styles.js';
import { ContactDetails } from './contact-details.js';
import { OnlineForm } from './online-form.js';

const HEADLINE = 'Sie möchten einen Schaden melden? Wir sind für Sie da!';

type ClaimReportCardProps = {
    tenantName: string;
    report: ClaimReport;
};

export function ClaimReportCard({ tenantName, report }: ClaimReportCardProps) {
    const styles = useStyles();

    return (
        <div className={styles.card}>
            <Title1 as="h2" className={styles.headline}>
                {HEADLINE}
            </Title1>

            {report.kind === 'form' ? (
                <OnlineForm url={report.url} accent={report.accent} tenantName={tenantName} />
            ) : (
                <ContactDetails phone={report.phone} email={report.email} accent={report.accent} />
            )}
        </div>
    );
}
